function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_370",
  "data-name": "Group 370",
  transform: "translate(-248.361 -170.337)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_86",
  "data-name": "Ellipse 86",
  cx: 2.782,
  cy: 2.782,
  rx: 2.782,
  ry: 2.782,
  transform: "translate(250.026 173.22) rotate(-25.373)",
  fill: "none",
  stroke: "#9b9eb9",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_434",
  "data-name": "Path 434",
  d: "M2121.3,1681.111a5.052,5.052,0,0,0-9.847-.024",
  transform: "translate(-1862.646 -1499.855)",
  fill: "none",
  stroke: "#9b9eb9",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.745,
    height: 11.368,
    viewBox: "0 0 10.745 11.368",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.186800de.svg";
export { ForwardRef as ReactComponent };